// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__132Lf","controls":"styles_controls__GYt7U","charLimit":"styles_charLimit__FRySm","input":"styles_input__2fOJT","send":"styles_send__3xcjG"};